import Vue from 'vue'
import VueRouter from 'vue-router'

//import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Settings from '../views/Settings.vue'
import Friends from '../views/Friends.vue'
import Games from '../views/Games.vue';
// import SEReferral from '../views/games/second-extinction/Referral.vue';
import SELeaderboard from '../views/games/second-extinction/Leaderboard.vue';
import EmailVerified from '../views/EmailVerified.vue';
import ResetPassword from '../views/ResetPassword.vue';
import TwitchConnect from '../views/TwitchConnect';
import Policy from '@/views/Policy.vue';
import ErrorView from '@/views/Error.vue';


import vueAuth from '@/plugins/auth.js';


Vue.use(VueRouter);


const metaDescription = "With APEX CONNECT, you become part of our special circle of friends. Signing up provides in-game rewards, unique game features, and ensures you'll never miss an update."

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
        title: "Avalanche Apex Connect",
        redirectIfLoggedIn: '/settings',
        metaTags: [
            {
                name: 'description',
                content: metaDescription
            },
            {
                property: 'og:description',
                content: metaDescription
            }
            ]
    },
    
    component: Register,
    props: {
        initialMode: 'register'
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: {
        initialMode: 'login'
    },
    meta: {
        title: "Avalanche Apex Connect | Login",
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    props: {
        initialMode: 'register'
    },
    meta: {
        title: "Avalanche Apex Connect | Register",
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      requiresAuth: true,
      title: "Avalanche Apex Connect | Account Settings",
    }
  },
  {
    path: '/friends',
    name: 'Friends',
    component: Friends,
    meta: {
      requiresAuth: true,
      title: "Avalanche Apex Connect | Your Friends",
    }
  },
  {
    path: '/games',
    name: 'Games',
    component: Games,
    meta: {
      requiresAuth: true,
      title: "Avalanche Apex Connect | Your Games",
    }
  },
  // {
  //   path: '/second-extinction/referral',
  //   name: 'Second Extinction Referral',
  //   component: SEReferral,
  //   meta: {
  //     requiresAuth: true,
  //     title: "Avalanche Apex Connect | Second Extinction Referral Program",
  //   }
  // },
  {
    path: '/second-extinction/leaderboard',
    name: 'Second Extinction Leaderboard',
    component: SELeaderboard,
    meta: {
      requiresAuth: true,
      title: "Avalanche Apex Connect | Second Extinction Leaderboard",
    }
  },  
  {
      path: '/policy/:identifier',
      name: 'Policies',
      component: Policy,
      meta: {
        requiresAuth: false,
        title: "Avalanche Apex Connect | Your Games",
      }
  },
  {
      path: '/twitch/:game',
      meta: {
        requiresAuth: true,
        title: "Avalanche Apex Connect | Twitch",
      },
      component: TwitchConnect,

  },
  {
      path: '/error',
      name: 'Error',
      component: ErrorView
  },
  {
    path: '/about',
    name: 'About',
    meta: {
        requiresAuth: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
      path: '/email-verified',
      name: 'Email Verified',
      component: EmailVerified,
  },
  {
    path: '/reset-password',
    alias: '/reset_password',
    name: 'Reset Password',
    component: ResetPassword,
   },
   // catch all route. has to be last.
   {
       path: '*',
       redirect: '/games',
   }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function(to, from, next) {
//is there a theme in the url? 
//if not check ssession storage
//if not, is asg theme

  let themeName;

  if ((from.query.theme || to.query.theme)) {
    themeName = from.query.theme ? from.query.theme : to.query.theme;

    sessionStorage.setItem("themeName", themeName);

    console.log('setting theme')
  } else if (sessionStorage.getItem("themeName")) {
    console.log('theme found');


  } else {
    console.log('setting asg theme')
    sessionStorage.setItem("themeName", 'asg');
  }

    // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(nearestWithMeta) {

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = vueAuth.isAuthenticated();
  if (!!to.matched[0].meta.redirectIfLoggedIn && isAuthenticated) {
    next({path: to.matched[0].meta.redirectIfLoggedIn});
  } else if (requiresAuth && !isAuthenticated) {
    const loginPath = window.location.pathname;
    next({name:'Register', query: {from: loginPath}});
  } else {
    next();
  }
})

export default router
